import { FC } from 'react';
import { Box, Grid, GridItem, HStack, Select, Spacer } from '@chakra-ui/react';
import { ListPageTitle } from 'components/atoms/ListPageTitle';
import { RegistrationButton } from 'components/atoms/RegistrationButton';
import { SearchFields } from 'components/molecules/SearchFields';

type Props = {
  searchValue: string;
  handleSearchValueChange: (value: string) => void;
  handleClickRegistration: () => void;
  handleSelectStatus: (status: string) => void;
};

export const CustomerHeaderView: FC<Props> = ({
  searchValue,
  handleSearchValueChange,
  handleClickRegistration,
  handleSelectStatus,
}) => (
  <Box m="40px 5px 0 5px">
    <Grid
      templateColumns="1fr 2fr 1fr 1fr"
      gap={0}
      justifyItems="start"
      alignItems="center"
      h="40px"
    >
      <GridItem>
        <ListPageTitle title="顧客一覧" />
      </GridItem>
      <GridItem w="100%">
        <SearchFields
          value={searchValue}
          handleChange={handleSearchValueChange}
        />
      </GridItem>
      <GridItem>
        <Spacer />
      </GridItem>
      <GridItem justifySelf="right">
        <HStack spacing={2}>
          <Select
            w="160px"
            onChange={(e) => handleSelectStatus(e.target.value)}
          >
            <option value="all">全て</option>
            <option value="using">契約中</option>
            <option value="canceled">解約済み</option>
          </Select>
          <RegistrationButton
            label="顧客情報の登録"
            width="160px"
            onClick={handleClickRegistration}
          />
        </HStack>
      </GridItem>
    </Grid>
  </Box>
);
